import React from 'react';
import { Upload, X, Image as ImageIcon } from 'lucide-react';

interface ImageUploadProps {
  label: string;
  image?: string;
  onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove?: () => void;
  isBanner?: boolean;
  disabled?: boolean;
}

export default function ImageUpload({ label, image, onUpload, onRemove, isBanner = false, disabled = false }: ImageUploadProps) {
  const aspectRatio = isBanner ? 'aspect-[3/1]' : 'aspect-square';

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-zinc-800 dark:text-stone-100">{label}</label>
      <div className={`relative ${aspectRatio} w-full rounded-xl border-2 border-dashed border-zinc-400 dark:border-zinc-600 overflow-hidden bg-stone-100 dark:bg-zinc-800`}>
        {image ? (
          <>
            <img src={image} alt={label} className="w-full h-full object-cover" />
            {!disabled && onRemove && (
              <button
                type="button"
                onClick={onRemove}
                className="absolute top-2 right-2 p-1.5 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </>
        ) : (
          <label className={`flex flex-col items-center justify-center w-full h-full cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-stone-200 dark:hover:bg-zinc-700'}`}>
            <input
              type="file"
              accept="image/*"
              onChange={onUpload}
              disabled={disabled}
              className="hidden"
            />
            <ImageIcon className="w-8 h-8 text-zinc-400 mb-2" />
            <span className="text-sm text-zinc-500 dark:text-stone-400">Upload image</span>
          </label>
        )}
      </div>
    </div>
  );
}
